import React from 'react';
import * as _ from 'lodash'
import { Button, ProgressBar, Form } from 'react-bootstrap';
import IosCalendar from 'react-ionicons/lib/IosCalendar'
import { copyObject } from '../../utils';

import IosAdd from 'react-ionicons/lib/IosAdd'

import IosArrowForward from 'react-ionicons/lib/IosArrowForward'
import Location from './Location';

import { useImmer } from 'use-immer';
import { LocationT } from '../../types/Job';
import { JobObj, LocationObj } from '../jobs/NewJob/InitObjectJob';
const styles = {
    left: {
        marginLeft: 0
    },
    required: {
        color: 'red'
    }
}

export type IScreenLocationsProps = {
    locations: Array<LocationT>
    nextScreen(locations: Array<LocationT>): void
}

const ScreenLocations: React.FC<IScreenLocationsProps> = (props) => {
    const [job, setJob] = React.useState(copyObject(JobObj))
    const [locations, setLocations] = React.useState([copyObject(LocationObj)])
    const [validated, setValidated] = React.useState<boolean>(false)



    React.useEffect(() => {
        if (!_.isEqual(locations, props.locations)) {
            setLocations(props.locations)
        }

    }, [props.locations])




    const addLocation = () => {
        let locationsClone = copyObject(locations)
        let cloneLocation = copyObject(LocationObj)
        locationsClone.push(cloneLocation)
        console.log("cloneLocation",cloneLocation)
        setLocations(locationsClone)

        // setLocations((draft) => {
        //     draft.push(copyObject(LocationObj))
        //     return draft;
        // })
    }




    const updateLocation = (index: number, location: LocationT) => {
        let locationsClone = copyObject(locations)
        locationsClone[index] = copyObject(location)
        setLocations(locationsClone)
    }





    const removeLocation = (index: number): void => {
        let locationsClone = copyObject(locations)

        const filteredItems = locationsClone.slice(0, index).concat(locationsClone.slice(index + 1, locationsClone.length))

        if (filteredItems.length <= 0) {
            let _item = copyObject(LocationObj)
            filteredItems.push(_item)
        }
        setLocations(filteredItems)

        // setLocations((draft) => {
        //     draft.splice(index, 1)
        //     if (draft.length <= 0) {
        //         draft.push(copyObject(LocationObj))
        //     }

        // })
    }



    const onSubmit = (event) => {
        event.preventDefault()
        event.stopPropagation()
        const form = event.currentTarget
        setValidated(true)
        console.log("form.checkValidity()", form.checkValidity())
        if (form.checkValidity() === true) {
            props.nextScreen(locations)
        }
    }
    // console.log("locations", locations)
    return (
        <div>
            <ProgressBar
                now={2 / 3 * 100}
                style={{ marginBottom: 30 }}
                variant="info" />
            <p>Tell us about your upcoming move.</p>
            <hr />
            <Form noValidate validated={validated} onSubmit={onSubmit}>
                {locations.map((location: LocationT, index: number): JSX.Element => {
                    return (
                        <Location
                            key={index}
                            index={index}
                            location={location}
                            removeLocation={removeLocation}
                            updateLocation={updateLocation} />
                    )
                })}
                <Button
                    onClick={(): void => {
                        // let tempJob: JobT = copyObject(job)
                        // tempJob.locations.push(copyObject(LocationObj))
                        // setJob(tempJob)
                        addLocation()
                    }}
                    style={styles.left}
                    variant="info">
                    <IosAdd color="white" />
                Add Location
            </Button>
                <br /><br />
                <Button
                    style={styles.left}
                    type="submit"
                    variant="success">
                    Next
                <IosArrowForward color="white" />
                </Button>
            </Form>
        </div>

    );
}
export default ScreenLocations